<template>
  <div class="base-title">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'baseTitle',
};
</script>

<style scoped lang="scss">
@import '~@/styles/theme.scss';
.base-title {
  height: 24px;
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  line-height: 24px;
  margin:16px 0;
}
.base-title:before {
  content: '';
  display: inline-block;
  width: 8px;
  height: 20px;
  background: $--color-primary;
  border-radius: 2px;
  margin-right: 16px;
}
</style>
